import React from "react";
import { useLocation } from "@reach/router";
import { SectionHeading, Wrapper, AnchorLink } from "@gw/component-library";
import { BaseLayout } from "../../layouts";
import { ChangePwd } from "../../components";
import { ChangePwdPageStyled } from "./ChangePwdPageStyled";
var ChangePwdPage = function () {
    var _a;
    var search = new URLSearchParams(useLocation().search);
    var code = (_a = search.get("code")) !== null && _a !== void 0 ? _a : undefined;
    return (React.createElement(BaseLayout, null,
        React.createElement(ChangePwdPageStyled, null,
            React.createElement(Wrapper, { className: "wrapper-auth" },
                React.createElement(AnchorLink, { to: "/" }, "\u2190 Back to Homepage"),
                React.createElement(SectionHeading, { className: "heading" }, "Reset Password"),
                React.createElement(ChangePwd, { codeParam: code })))));
};
export default ChangePwdPage;
//# sourceMappingURL=ChangePwdPage.js.map